import { render } from "./header_component.vue?vue&type=template&id=4d70a0ae&scoped=true"
import script from "./header_component.vue?vue&type=script&lang=js"
export * from "./header_component.vue?vue&type=script&lang=js"

import "./header_component.vue?vue&type=style&index=0&id=4d70a0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d70a0ae"]])

export default __exports__